/* Reveal-on-scroll for editorial sections (lookbook, homepage bands).
   Matches the prototype: IntersectionObserver toggles .is-in on enter AND exit,
   so sections fade back out when they leave the viewport.
   Honors prefers-reduced-motion and a per-section [data-reveal-enabled="false"]. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    if (reduce.matches) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-in', entry.isIntersecting);
      });
    }, { threshold: 0.05, rootMargin: '-4% 0px -8% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      // A section can opt out of motion via its theme-editor toggle.
      if (el.closest('[data-reveal-enabled="false"]')) {
        el.classList.add('is-in');
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
